<template>
   <el-tabs type="border-card">
    <el-tab-pane label="物流公司列表">
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="companyForm" class="demo-form-inline">
          <el-form-item label="物流公司名称">
            <el-input v-model.trim="companyForm.name" placeholder="物流公司名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="onSubmit" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top:10px;">
        <el-table
          :data="data"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            width="260"
            show-overflow-tooltip
            label="物流公司名称">
          </el-table-column>
          <el-table-column
            prop="code"
            show-overflow-tooltip
            label="物流公司拼写">
          </el-table-column>
          <el-table-column
            width="240"
            prop="createDate"
            label="创建时间">
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      companyForm: {
        name: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getExpressCompanyList()
  },
  methods: {
    getExpressCompanyList: function() {
      this.optionItem = this.common.extend(this.companyForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/expressCompany/list',this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    onSubmit: function() {
      this.getExpressCompanyList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getExpressCompanyList()
    },
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/system/company/expressCompanyList.vue